import React from 'react';
import { Link } from 'react-router-dom';
import { useNavState } from '../../hooks/useNavState';
import { clearConsent } from '../../consent/consent';

const Footer = () => {
  const { isAuthenticated } = useNavState();
  
  return (
    <footer className="bg-gray-900 border-t border-gray-800 py-12 px-6">
      <div className="container mx-auto">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-display tracking-[0.2em] uppercase text-white mb-4">ElectricNOW</h3>
            <p className="text-gray-400 text-sm mb-4">
              Your destination for classic movies and timeless TV shows. 
              Free streaming with a curated selection of entertainment gems.
            </p>
            {/* Social media links */}
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/electricnowtv/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#9ec6f0] transition-colors">
                <span className="sr-only">Facebook</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="https://twitter.com/electricent1" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#9ec6f0] transition-colors">
                <span className="sr-only">Twitter / X</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a href="https://www.youtube.com/channel/UCQShCYQdbXdRn2GIO5YFf3Q" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#9ec6f0] transition-colors">
                <span className="sr-only">YouTube</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/electricentertainmentofficial" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#9ec6f0] transition-colors">
                <span className="sr-only">Instagram</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-lg font-display tracking-[0.2em] uppercase text-white mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/live-tv" className="text-gray-400 hover:text-[#9ec6f0] transition-colors text-sm">
                  Live TV
                </Link>
              </li>
              <li>
                <Link to="/movies" className="text-gray-400 hover:text-[#9ec6f0] transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/series" className="text-gray-400 hover:text-[#9ec6f0] transition-colors text-sm">
                  Español
                </Link>
              </li>
              <li>
                <Link to="/devices" className="text-gray-400 hover:text-[#9ec6f0] transition-colors text-sm">
                  Devices
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-display tracking-[0.2em] uppercase text-white mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#9ec6f0] transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-[#9ec6f0] transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <a href="mailto:support@electricnow.tv" className="text-gray-400 hover:text-[#9ec6f0] transition-colors text-sm">
                  Email Support
                </a>
              </li>
              <li>
                <a href="mailto:datarequest@electricnow.tv" className="text-gray-400 hover:text-[#9ec6f0] transition-colors text-sm">
                  Privacy Requests
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-display tracking-[0.2em] uppercase text-white mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-[#9ec6f0] transition-colors text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-use" className="text-gray-400 hover:text-[#9ec6f0] transition-colors text-sm">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/ccpa" className="text-gray-400 hover:text-[#9ec6f0] transition-colors text-sm">
                  CCPA Rights
                </Link>
              </li>
              <li>
                <Link to="/do-not-sell" className="text-gray-400 hover:text-[#9ec6f0] transition-colors text-sm">
                  Do Not Sell My Data
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => { clearConsent(); window.location.reload(); }}
                  className="text-gray-400 hover:text-[#9ec6f0] transition-colors text-sm bg-transparent border-0 p-0 cursor-pointer"
                >
                  Cookie Preferences
                </button>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              &copy; {new Date().getFullYear()} ElectricNOW. All rights reserved.
              {isAuthenticated && (
                <span className="ml-2">| Authenticated User</span>
              )}
            </div>
            <div className="flex flex-wrap gap-4 text-sm">
              {/* Removed duplicate links - they're already in the Legal section above */}
              {/* Hidden Matrix Easter Egg */}
              <button 
                onClick={() => {
                  // Create Matrix effect on click
                  const matrixModal = document.createElement('div');
                  matrixModal.className = 'fixed inset-0 bg-black z-50 flex items-center justify-center';
                  matrixModal.innerHTML = `
                    <div class="text-center">
                      <div class="text-6xl font-mono text-green-400 mb-4 animate-pulse">🐰</div>
                      <h2 class="text-3xl font-mono text-green-400 mb-4">Follow the White Rabbit</h2>
                      <p class="text-green-300 font-mono mb-6">You found the hidden path, Neo.</p>
                      <p class="text-green-500/80 font-mono text-sm mb-8">"The Matrix has you..."</p>
                      <button class="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded font-mono transition-colors" onclick="this.parentElement.parentElement.remove()">
                        Take the Red Pill
                      </button>
                    </div>
                  `;
                  document.body.appendChild(matrixModal);
                  
                  // Auto-remove after 10 seconds
                  setTimeout(() => {
                    if (matrixModal.parentElement) {
                      matrixModal.remove();
                    }
                  }, 10000);
                }}
                className="text-gray-600 hover:text-green-400 transition-colors text-xs opacity-30 hover:opacity-100"
                title="🐰"
              >
                ·
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
